import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/page/Login'
import LoginSimulasi from '@/page/LoginSimulasi'
import CLoA from '@/page/CLoA.vue'
import RLoA from '@/page/RLoA.vue'
import Form from '@/page/register/Form'
import KartuUjian from '@/page/register/Kartu'
import CekPembayaranPub from '@/page/CekPembayaranPub'
import DashboardPendaftar from '@/page/DashboardPendaftar'
import ArtikelDetail from '@/page/information/ArtikelDetail'
import ArtikelCardList from '@/page/information/ArtikelCardList'
import PengumumanDetail from '@/page/information/PengumumanDetail'
import store from '../store'

Vue.use(Router)

let router = new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login,
      beforeEnter: (to, from, next) => {
        if (!store.state.auth.isLogin) {
          next()
        } else {
          next({ name: 'DashboardPendaftar' })
        }
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      beforeEnter: (to, from, next) => {
        if (!store.state.auth.isLogin) {
          next()
        } else {
          next({ name: 'DashboardPendaftar' })
        }
      }
    },
    {
      path: '/dashboard',
      name: 'DashboardPendaftar',
      component: DashboardPendaftar,
      beforeEnter: (to, from, next) => {
        if (store.state.auth.isLogin) {
          next()
        } else {
          next({ name: 'Login' })
        }
      }
    },
    {
      path: '/dashboard/card-berita',
      name: 'ArtikelCardList',
      component: ArtikelCardList,
      beforeEnter: (to, from, next) => {
        if (store.state.auth.isLogin) {
          next()
        } else {
          next({ name: 'Login' })
        }
      }
    },
    {
      path: '/dashboard/berita/:id_berita',
      name: 'ArtikelDetail',
      component: ArtikelDetail,
      beforeEnter: (to, from, next) => {
        if (store.state.auth.isLogin) {
          next()
        }
      }
    },
    {
      path: '/dashboard/pengumuman/:id_pengumuman',
      name: 'PengumumanDetail',
      component: PengumumanDetail,
      beforeEnter: (to, from, next) => {
        if (store.state.auth.isLogin) {
          next()
        }
      }
    },
    {
      path: '/register/form',
      name: 'RegisterForm',
      component: Form,
      beforeEnter: (to, from, next) => {
        if (store.state.auth.isLogin) {
          next()
        } else {
          next({ name: 'Login' })
        }
      }
    },
    {
      path: '/conditional-loa',
      name: 'CLoA',
      component: CLoA,
      beforeEnter: (to, from, next) => {
        if (store.state.auth.isLogin) {
          next()
        } else {
          next({ name: 'Login' })
        }
      }
    },
    {
      path: '/regular-loa',
      name: 'RLoA',
      component: RLoA,
      beforeEnter: (to, from, next) => {
        if (store.state.auth.isLogin) {
          next()
        } else {
          next({ name: 'Login' })
        }
      }
    },
    {
      path: '/register/kartu',
      name: 'KartuUjian',
      component: KartuUjian,
      beforeEnter: (to, from, next) => {
        if (store.state.auth.isLogin) {
          if (store.state.verification.verificationSuccess) {
            next()
          } else {
            next({ name: 'DashboardPendaftar' })
          }
        } else {
          next({ name: 'Login' })
        }
      }
    },
    {
      path: '/simulasi-bayar',
      name: 'SimulasiBayar',
      component: LoginSimulasi
    },
    {
      path: '/login/simulasi-bayar',
      name: 'SimulasiBayar',
      component: LoginSimulasi
    },
    {
      path: '/cek_password',
      name: 'CekPassword',
      component: CekPembayaranPub
    },
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js